// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"0a8af199","264":"df4e8e22","452":"9cd244fb","580":"2491f452","599":"38aea034","916":"3b87d84c"}[chunkId] + ".chunk.js";
};